export function useObjectStorageSerializer<T extends object>() {
  return {
    read: (value: string) => (value ? (JSON.parse(value) as T) : undefined),
    write: (value: T | undefined) => JSON.stringify(value),
  }
}
